import React, { useEffect } from "react";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { Outlet } from "react-router-dom";
import LoginPopup from "../../components/auth/LoginPopup";
import appInsights from "../../applicationInsights";

//TODO: Error boundary
export const DefaultPageLayout: React.FC = () => {
    
    const msal = useMsal();

    useEffect(() => {
        appInsights.setAuthenticatedUserContext(msal.accounts[0]?.idTokenClaims["oid"]);
    }, []);

    const getLoginDomains = () => process.env.REACT_APP_LOGIN_DOMAINS.split(',');

    const onLoginButtonClicked = async (loginHint: string) => await msal.instance.loginRedirect({
        scopes: [`api://${process.env.REACT_APP_CLIENT_ID}/user_impersonation`],
        loginHint: loginHint
    });
    
    return (
        <>
            <UnauthenticatedTemplate>
                <LoginPopup loginDomains={getLoginDomains()} onLoginButtonClicked={onLoginButtonClicked} />
            </UnauthenticatedTemplate>
            <AuthenticatedTemplate>
                <Outlet />
            </AuthenticatedTemplate>
        </>
    );
};
